import { Location } from "../organisation/Location"
import { Person } from "../person/Person"
import { current_stage } from "./OpportunityModel"

export enum persona_type {
    Growth_Newbie_Agent = "Growth_Newbie_Agent",
    Growth_Spinoff_Agent = "Growth_Spinoff_Agent",
    Growth_Warrior_Agent = "Growth_Warrior_Agent",
    Growth_Master_Agent = "Growth_Master_Agent",
    Growth_Farmer = "Growth_Farmer",
    Community_Agent = "Community_Agent",
    Community_Fruit_Director = "Community_Fruit_Director",
    Community_Mill_Official = "Community_Mill_Official",
    Community_Transporter = "Community_Transporter",
    Community_Village_Official = "Community_Village_Official",
    Community_Farmer = "Community_Farmer"
}

export enum source_type {
    Whatsapp = "Whatsapp",
    Tiktok = "Tiktok",
    IG_FB = "IG_FB",
    UL = "UL"
}

export enum contact_status {
    active = "active",
    no_response = "no_response",
    waiting_on_client = "waiting_on_client"
}

export const contactStatusLabelMap: Record<contact_status, string> = {
    [contact_status.active]: 'Active',
    [contact_status.no_response]: 'No Response',
    [contact_status.waiting_on_client]: 'Waiting on Client',
};

export enum qualification {
    Hot = "Hot",
    Warm = "Warm",
    Cold = "Cold",
    DontKnowYet = "DontKnowYet"
}

export const qualificationLabelMap: Record<qualification, string> = {
    [qualification.Hot]: 'Hot',
    [qualification.Warm]: 'Warm',
    [qualification.Cold]: 'Cold',
    [qualification.DontKnowYet]: "Don't Know Yet",
};

type Postion = {
    coordinates: number[]
}

export class ContactModel {

    id: number
    email: string
    first_name?: string
    last_name?: string
    phonenumber?: string
    location?: Location
    created_at?: string
    updated_at?: string
    activestatus?: contact_status
    source?: source_type
    sourceLink?: string
    persona_type?: persona_type
    qualification?: qualification
    position?: Postion
    person?: Person

    constructor(c: any) {
        this.id = c.id
        this.email = c.email
        this.first_name = c.first_name
        this.last_name = c.last_name
        this.phonenumber = c.mobile_number ?? c.phonenumber
        this.location = c.location && Location.build(c.location)
        this.created_at = c.created_at
        this.updated_at = c.updated_at
        this.activestatus = c.activestatus
        this.source = c.source
        this.sourceLink = c.social_media_url
        this.persona_type = c.persona_type
        this.qualification = c.qualification
        this.position = c.position
        this.person = c.person && Person.buildCRMPerson(c.person)
    }

    isHot(): boolean {
        return this.qualification === qualification.Hot;
    }
    isWarm(): boolean {
        return this.qualification === qualification.Warm;
    }
    isCold(): boolean {
        return this.qualification === qualification.Cold;
    }
    isDontKnowYet(): boolean {
        return this.qualification === qualification.DontKnowYet;
    }
    address(): string|undefined {
        if (!this.location) return undefined
        return `${this.location?.province}, ${this.location?.district}, ${this.location?.subDistrict}, ${this.location?.village}`
    }

    name(): string | undefined {
        return this.person?.getFullName() ? this.person?.getFullName() : `${this.first_name}${this.last_name ? ' ' + this.last_name :''}`
    }

    getFirstName(): string | undefined {
        return this.person?.firstname ? this.person?.firstname : this.first_name
    }

    getLastName(): string | undefined {
        return this.person?.lastname ? this.person?.lastname : this.last_name
    }

    static buildContact(c: any): ContactModel {
        return new ContactModel(c)
    }
}

export const personaTypeLabelMap: Record<persona_type, string> = {
    [persona_type.Growth_Newbie_Agent]: 'Growth Newbie Agent',
    [persona_type.Growth_Spinoff_Agent]: 'Growth Spinoff Agent',
    [persona_type.Growth_Warrior_Agent]: 'Growth Warrior Agent',
    [persona_type.Growth_Master_Agent]: 'Growth Master Agent',
    [persona_type.Growth_Farmer]: 'Growth Farmer',
    [persona_type.Community_Agent]: 'Community Agent',
    [persona_type.Community_Fruit_Director]: 'Community Fruit Director',
    [persona_type.Community_Mill_Official]: 'Community Mill Official',
    [persona_type.Community_Transporter]: 'Community Transporter',
    [persona_type.Community_Village_Official]: 'Community Village Official',
    [persona_type.Community_Farmer]: 'Community Farmer',
};